module.exports = __webpack_public_path__ + "img/20180815_151538_167.c8319779.jpg";